export const kur = (ayar, pb) => (pb === "TRY" || !pb ? 1 : Number(ayar?.kurlar?.[pb] || 0));
export const tlUsd = (ayar, tl) => { const k = kur(ayar, "USD"); return k ? (tl || 0) / k : 0; };
export const usdFmt = (v, d = 5) => `${(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: d })} USD`;
export const sureYaz = (sn) => { const s = Math.max(0, Math.round(sn || 0)); return [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60].map((x) => String(x).padStart(2, "0")).join(":"); };
export const sureOku = (t) => { const p = String(t || "").split(":").map((x) => Number(x) || 0); while (p.length < 3) p.unshift(0); return p[0] * 3600 + p[1] * 60 + p[2]; };
export const karHesap = (ayar, u) => {
  const satis = (u.satis_fiyati || 0) * kur(ayar, u.para_birimi) / (kur(ayar, "USD") || 1);
  const maliyet = tlUsd(ayar, u.cogs);
  const k = satis - maliyet;
  return { satis, maliyet, kar: k, marj: satis > 0 ? (k / satis) * 100 : 0 };
};
